import artistHelpDe from '@/messages/artist-help/de.json';
import artistHelpEn from '@/messages/artist-help/en.json';
import artistHelpEs from '@/messages/artist-help/es.json';
import artistHelpFr from '@/messages/artist-help/fr.json';
import artistHelpIt from '@/messages/artist-help/it.json';
import artistHelpPt from '@/messages/artist-help/pt.json';
import collectorsHelpDe from '@/messages/collectors-help/de.json';
import collectorsHelpEn from '@/messages/collectors-help/en.json';
import collectorsHelpEs from '@/messages/collectors-help/es.json';
import collectorsHelpFr from '@/messages/collectors-help/fr.json';
import collectorsHelpIt from '@/messages/collectors-help/it.json';
import collectorsHelpPt from '@/messages/collectors-help/pt.json';
import commonDe from '@/messages/common/de.json';
import commonEn from '@/messages/common/en.json';
import commonEs from '@/messages/common/es.json';
import commonFr from '@/messages/common/fr.json';
import commonIt from '@/messages/common/it.json';
import commonPt from '@/messages/common/pt.json';
import galleriesHelpDe from '@/messages/galleries-help/de.json';
import galleriesHelpEn from '@/messages/galleries-help/en.json';
import galleriesHelpEs from '@/messages/galleries-help/es.json';
import galleriesHelpFr from '@/messages/galleries-help/fr.json';
import galleriesHelpIt from '@/messages/galleries-help/it.json';
import galleriesHelpPt from '@/messages/galleries-help/pt.json';

const messages = {
  en: { common: commonEn, galleries_help: galleriesHelpEn, collectors_help: collectorsHelpEn, artist_help: artistHelpEn },
  es: { common: commonEs, galleries_help: galleriesHelpEs, collectors_help: collectorsHelpEs, artist_help: artistHelpEs },
  de: { common: commonDe, galleries_help: galleriesHelpDe, collectors_help: collectorsHelpDe, artist_help: artistHelpDe },
  it: { common: commonIt, galleries_help: galleriesHelpIt, collectors_help: collectorsHelpIt, artist_help: artistHelpIt },
  fr: { common: commonFr, galleries_help: galleriesHelpFr, collectors_help: collectorsHelpFr, artist_help: artistHelpFr },
  pt: { common: commonPt, galleries_help: galleriesHelpPt, collectors_help: collectorsHelpPt, artist_help: artistHelpPt },
};

export default messages;
